import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom fontWeight={700}>Privacy Policy</Typography>
      <Typography variant="subtitle1" color="text.secondary" paragraph>
        Your privacy matters. We collect only what is necessary to process and deliver your order.
      </Typography>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Data We Collect</Typography>
        <List dense>
          <ListItem><ListItemText primary="Account information (name, email, contact)" /></ListItem>
          <ListItem><ListItemText primary="Order and shipping details" /></ListItem>
          <ListItem><ListItemText primary="Uploaded images and customization inputs" /></ListItem>
        </List>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>How We Use It</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Solely for order processing, production, communication, and delivery. We do not sell, rent, or repurpose your personal data.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Image Retention & Deletion</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Uploaded customer images are automatically deleted 15 days after the order is marked completed. This helps protect your privacy and storage hygiene.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Security</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          We apply industry practices for storage and access control. No system is 100% secure, but we actively monitor and improve safeguards.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Your Rights</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          You may request deletion of your account data (subject to legal/tax record requirements). For any concerns, email privacy@therandomstore.com.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Policy Updates</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Updates will be posted here with an updated revision date.
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
